export enum gCoinsRequestStatus {
  Pending = 'pending',
  Confirmed = 'confirmed',
  Ordered = 'ordered',
}
